import { render, staticRenderFns } from "./SquareMeterItem.vue?vue&type=template&id=5b9908ac&scoped=true&"
import script from "./SquareMeterItem.vue?vue&type=script&lang=js&"
export * from "./SquareMeterItem.vue?vue&type=script&lang=js&"
import style0 from "./SquareMeterItem.vue?vue&type=style&index=0&id=5b9908ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9908ac",
  null
  
)

export default component.exports